import { FETCH_FICHAS_VENTA, LOADING_FICHAS_VENTA, FETCH_FICHA_VENTA,FETCH_FICHA_VENTA_CORREOS } from '../actions';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_FICHAS_VENTA:
      return action.payload.data;
    case LOADING_FICHAS_VENTA:
      return null;
    case FETCH_FICHA_VENTA:
      return action.payload.data;
      case FETCH_FICHA_VENTA_CORREOS:
        return !action.payload.data ? [] : action.payload.data.listaCorreos;//Req 92528 ebarboza 30 08 2021
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/FichasVenta.js